import React, { Component } from 'react';
import { Form, Button, Col, Modal, message } from "antd";
import InputForm from "../components/InputForm";
import { validateSenha, checkFormIsValid } from "../utils/Validator";
import axios from "axios";
import { getUsuario } from "../utils/LoginManager";

const ItemForm = Form.Item;

export default class extends Component {
    state = {}

    onChange = event => {
        const value = event.target.value;
        const id = event.target.id;
        this.setState({
            [id]: value
        });
    };

    componentDidMount() {
        this.buscaSenha();
    }

    // mensagemAviso = () => {
    //     Modal.warning({
    //         title: 'This is a warning message',
    //         content: 'some messages...some messages...',
    //     });
    // }

    buscaSenha = (value) => {
        const usuario = getUsuario();

        this.setState({
            carregando: false,
            usuario: usuario.usu_cpf,
        });
        axios.get(`/usuarios/showSenha/${usuario.usu_cpf}`)
            .then(response => {
                const { data } = response;
                this.setState({
                    senha: data.usu_senha,
                })
            }).catch(error => {
                console.error(error.response);
            })
    }


    onGravarClick = () => {
        const { usuario, senha, senhaAtual, novaSenha1, novaSenha2 } = this.state;

        console.log('onGravarClick', this.state)

        if (novaSenha1 !== novaSenha2) {
            Modal.warning({
                title: 'Aviso!',
                content: 'As novas senhas não conferem.',
            });
        } else if (checkFormIsValid(this.refs)) {

            this.setState({
                salvando: true,
            })

            axios.put(`/usuarios/updateSenha/${usuario}`, {
                senha: novaSenha1,
            })
                .then(response => {
                    this.setState({
                        salvando: false,
                        senhaAtual: "",
                        novaSenha1: "",
                        novaSenha2: "",
                    });
                    message.success('Senha Alterada com Sucesso.');
                })
                .catch(error => {
                    console.error(error.response);
                    this.setState({
                        salvando: false,
                    })
                    Modal.error({ title: 'Atenção!', content: error.response.data.mensagem, okText: 'OK', })
                })

        }
    };


    render() {
        const { senhaAtual, novaSenha1, novaSenha2, salvando } = this.state;
        return (
            <div className="contentRoutesContainer">
                <Form onSubmit={this.onLogin}>
                    <ItemForm>
                        <h2 className="tituloPage">Alterar Senha do Usuário</h2>
                    </ItemForm>

                    {/* <Col xs={24} sm={5} className="avaliacoesPageFiltro-camposBusca">
                        <span>Senha Atual</span>
                        <InputForm
                            type="password"
                            id="senhaAtual"
                            ref="senhaAtual"
                            title="Digite a Senha"
                            placeholder="Digita a Senha Atual"
                            size="large"
                            maxLength={15}
                            required
                            validator={validateSenha}
                            value={senhaAtual}
                            onChange={this.onChange}
                            errorMessage="Senha Inválida"
                        />
                    </Col> */}

                    <Col xs={24} sm={5} className="avaliacoesPageFiltro-camposBusca">
                        <span>Nova Senha</span>
                        <InputForm
                            type="password"
                            id="novaSenha1"
                            ref="novaSenha1"
                            title="Digite a Senha"
                            placeholder="Digita a Nova Senha"
                            size="large"
                            maxLength={15}
                            required
                            validator={validateSenha}
                            value={novaSenha1}
                            onChange={this.onChange}
                            errorMessage="Senha Inválida"
                        />
                    </Col>

                    <Col xs={24} sm={5} className="avaliacoesPageFiltro-camposBusca">
                        <span>Confirme a Nova Senha</span>
                        <InputForm
                            type="password"
                            id="novaSenha2"
                            ref="novaSenha2"
                            title="Digite a Senha"
                            placeholder="Confirme a Nova Senha"
                            size="large"
                            maxLength={15}
                            required
                            validator={validateSenha}
                            value={novaSenha2}
                            onChange={this.onChange}
                            errorMessage="Senha Inválida"
                        />
                    </Col>

                    <Col xs={24} sm={4} className="avaliacoesPageFiltro-camposBusca" style={{ marginTop: 20 }}>
                        <ItemForm>
                            <Button
                                htmlType="submit"
                                className="login-botao"
                                size="large"
                                loading={salvando}
                                onClick={this.onGravarClick}
                            >
                                Salvar Senha
                            </Button>
                        </ItemForm>
                    </Col>

                </Form>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/AlterarSenhaPage.js